import Node from "./NodeAccess";
import Assign from "./AssignRoles";

export const NodeAccess = Node;
export const AssignRoles = Assign;